// @ts-ignore
const PrimaryContainer = ({ children }) => {
  return (
    <div className="flex flex-col justify-between min-h-screen dark:bg-gray-800 bg-gray-100 text-gray-800 dark:text-gray-100">
      {children}
    </div>
  );
};
export default PrimaryContainer;
